<template>
  <div class="f-becomeSupporterModal">
    <b-modal id="becomeSupporterModal"
             ref="becomeSupporterModal"
             centered
             size="lg"
             :title="activeLanguage.becomeSupporter">
      <p class="my-4 citation" id="captionText">
        Contenuto
      </p>

      <div slot="modal-footer" class="w-100">
        <b-button class="button-style-grey float-right"
                  style="margin-left: 2%"
                  @click="hideModal">{{activeLanguage.close}}
        </b-button>
        <b-button class="button-style float-right">Download</b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
    export default {
      name: 'BecomeSupporterModal',
      computed: {
        activeLanguage () {
          return this.$translations[this.$store.getters.currentLanguageValue]
        }
      },
      methods: {
        showModal () {
          this.$refs.becomeSupporterModal.show()
        },
        hideModal () {
          this.$refs.becomeSupporterModal.hide()
        }
      },
      mounted () {
        document.getElementById('becomeSupporterModal___BV_modal_header_').setAttribute('style', 'background-color: #c41c21 !important; color: white !important;')
        document.getElementById('becomeSupporterModal___BV_modal_header_').lastChild.setAttribute('style', 'color: white !important;')
      }
    }
</script>

<style scoped>

  .button-style {
    background-color: #c41c21 !important;
    border-color: #c41c21 !important;
  }

  .citation {
    font-style: italic;
    font-variant: petite-caps;
    font-size: 1.2em;
    font-weight: 500;
  }

</style>



// WEBPACK FOOTER //
// src/components/pagesComponents/supportersPageComponents/BecomeSupporterModal.vue